import Footer from './footer/script';
import Gallery from './gallery/script';
import GridNews from './grid-news/script';
import Header from './header/script';
import Heroes from './heroes/index';
import Sliders from './sliders/index';
import Splits from './splits/index';
import TwoWays from './two-ways/script';
import Quotes from './quotes/script';
import Wip from './wip/script';
import Work from './work/script';

export default {
	[Footer.selector]: Footer,
	[Gallery.selector]: Gallery,
	[GridNews.selector]: GridNews,
	[Header.selector]: Header,
	[TwoWays.selector]: TwoWays,
	[Quotes.selector]: Quotes,
	[Wip.selector]: Wip,
	[Work.selector]: Work,
	...Heroes,
	...Sliders,
	...Splits
};
